import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard,
  Users,
  CalendarClock,
  UserPlus,
  Ticket,
  ShoppingCart,
  Settings,
  ChevronDown,
  MessageSquare,
  Image as ImageIcon,
  History
} from 'lucide-react';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/clients', label: 'Clients', icon: Users },
    { path: '/client-history', label: 'Client History', icon: History },
    { path: '/follow-ups', label: 'Follow-ups', icon: CalendarClock },
    { path: '/potential-customers', label: 'Potential Customers', icon: UserPlus },
    { path: '/coupons', label: 'Coupons', icon: Ticket },
    { path: '/woocommerce', label: 'WooCommerce', icon: ShoppingCart },
    { path: '/whatsapp', label: 'WhatsApp Broadcast', icon: MessageSquare },
    { path: '/media', label: 'Media Library', icon: ImageIcon },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <aside className="fixed left-0 top-0 h-screen w-[208px] bg-[#1e3a5f] flex flex-col z-50">
      {/* Logo Section */}
      <div className="px-4 py-4">
        <div className="flex items-center gap-2 mb-1">
          <img 
            src="https://quikmaster.com/img/quikmaster-logo-final-01-2.png" 
            alt="QuikMaster" 
            className="h-8 object-contain brightness-0 invert"
          />
        </div>
        <h1 className="text-white text-lg font-bold">QuikMaster CRM</h1>
        <p className="text-gray-400 text-xs">Client Management</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 transition-colors ${
                  isActive
                    ? 'bg-[#2d4a6f] text-white'
                    : 'text-gray-300 hover:bg-[#2d4a6f]/50 hover:text-white'
                }`
              }
            >
              <Icon size={18} />
              <span className="text-sm">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* User Profile */}
      <div className="px-3 py-4 border-t border-[#2d4a6f]">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-3 py-2 rounded-lg hover:bg-[#2d4a6f]/50 transition-colors group"
        >
          <div className="w-8 h-8 rounded-full bg-[#4F46E5] flex items-center justify-center text-white text-sm font-medium">
            {user?.name?.charAt(0) || 'E'}
          </div>
          <div className="flex-1 text-left">
            <p className="text-white text-sm font-medium">{user?.name || 'Edward'}</p>
            <p className="text-gray-400 text-xs capitalize">{user?.role || 'Admin'}</p>
          </div>
          <ChevronDown size={16} className="text-gray-400 group-hover:text-white" />
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
